import { getToken, isTokenExpired, refreshToken } from 'auth/AuthService'
import axios, { AxiosInstance, AxiosResponse } from 'axios'

export type ResponseInterceptor<T> = {
  success: boolean
} & AxiosResponse<T>

const request = axios.create()

request.interceptors.request.use(
  async (config) => {
    if (isTokenExpired()) {
      await refreshToken()
    }

    const token = getToken()

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    return { ...response, success: true }
  },
  async (error) => {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken()

      if (refreshed) {
        const originalRequest = error.config
        const token = getToken()

        if (token) {
          originalRequest.headers.Authorization = `Bearer ${token}`
        }
        return request(originalRequest)
      } else {
        window.location.reload()
      }
    }
    return Promise.reject(error)
  }
)

export default request as AxiosInstance
